<div class="py-2  mt-1 mb-2 gap-2" id="swiperFiltersArray">
    <swiper [config]="configSwiperEachFilter">
        <ng-template swiperSlide *ngFor="let eachFilter of filtersArray">
            <button (click)="toggleFilter(eachFilter.id, eachFilter.name)" 
    
            class="{{eachFilter.isActive ? 'bg-blue-500 text-white' : 'bg-white'}} border border-solid border-black-50 px-4 py-2 rounded-full flex justify-center items-center whitespace-nowrap">
            <!-- <i class="ico-Filter text-xl mx-1 font-bold"></i> -->
            <span class="font-semibold text-sm">{{ eachFilter.name }}</span>
        </button>
        </ng-template>
    </swiper>
</div>